import { render, staticRenderFns } from "./_FailureReport.vue?vue&type=template&id=664824df&scoped=true&"
import script from "./_FailureReport.vue?vue&type=script&lang=js&"
export * from "./_FailureReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664824df",
  null
  
)

export default component.exports